// Default toggle slide-over functionality
import useBreakpoints from "../functions/useBreakpoints";

export const slideOver = () => {
    const {isBreakpoint} = useBreakpoints();

    const toggleSlide = (strTarget) => {
        if (!strTarget) {
            return;
        }

        const objSlide = document.querySelector(`[data-slide^="${strTarget}"]`);
        if (objSlide) {
            objSlide.classList.toggle('active');
        }
    };

    const closeAll = (strTarget = "mobilemenu") => {
        // Close all active slide-over implementations
        const objSlides = document.querySelectorAll(`[data-slide^="${strTarget}"]`);
        if (objSlides?.length > 0) {
            objSlides.forEach(slide => {
                if (slide.classList.contains('active')) {
                    slide.classList.remove('active');
                }
            });
        }
    };

    const init = () => {
        const slideOverBtns = document.querySelectorAll('[data-action^=\'slide-\']');
        if (slideOverBtns?.length === 0) {
            return;
        }

        slideOverBtns.forEach(btn => {
            btn.addEventListener('click', (event) => {
                // The toggle functionality only fires on screensizes 'lg' and upwards when element has the class "desktop-only"
                if (event.currentTarget.classList.contains('desktop-only') && !isBreakpoint('lg')) {
                    return;
                }

                event.preventDefault();

                // Toggle the 'active' class on the slide element associated with the button
                const strTarget = event.currentTarget.getAttribute('data-target');

                if (event.currentTarget.hasAttribute('data-close') && event.currentTarget.getAttribute('data-close') === "all") {
                    if (strTarget === 'cart') {
                        closeAll(strTarget);
                    } else {
                        closeAll();
                    }
                } else {
                    toggleSlide(strTarget);
                }

                // When clicked on the fixed background close the slide-over
                const fixedBg = document.querySelector(`[data-slide="${strTarget}"] .bg-fixed`);
                if (fixedBg) {
                    fixedBg.addEventListener('click', (event) => {
                        const computedStyle = window.getComputedStyle(fixedBg);
                        if (computedStyle.getPropertyValue("position") === "fixed") {
                            if (strTarget === 'cart') {
                                closeAll(strTarget);
                            } else {
                                closeAll();
                            }
                        }
                    });
                }
            });
        });
    };

    return {
      init
    }
};

